import { ReactElement } from 'react'
import DriverDetails from '../../components/Driver/Details'
import Layout from '../../components/layout'

const DriversDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <DriverDetails />
    </Layout>
  )
}

export default DriversDetailsPage
